<template>
  <div class="privacy-rules">
    <p class="title">
      隐私政策
    </p>

    <p class="paragraph">
      版本：V2.1
    </p>
    <p class="paragraph">
      版本更新日期：2025年9月29日
    </p>
    <p class="paragraph">
      版本更新日期：2025年9月29日
    </p>
    <p class="paragraph">
      引言
    </p>
    <p class="paragraph">
      我们非常重视您的隐私和个人信息保护。本隐私政策详细说明了我们如何收集、使用、保护和共享您的个人信息，以及您作为用户拥有的权利。
    </p>

    <p class="paragraph">
      请在使用我们的产品（或服务）前，仔细阅读并了解本隐私政策。
    </p>

    <p class="paragraph">
      一、收集和使用用户信息
    </p>
    <p class="paragraph">
      1. 信息收集：我们仅收集为提供服务所必需的个人信息，包括但不限于用户注册信息、设备信息、使用习惯等。
    </p>
    <p class="paragraph">
      2. 信息使用：我们使用您的信息以提供服务、改进产品、进行客户支持、安全防范和反欺诈监测。
    </p>

    <p class="paragraph">
      二、用户授权同意
    </p>
    <p class="paragraph">
      1. 授权同意：您有权选择是否提供个人信息。未提供必要信息可能导致服务无法使用。
    </p>
    <p class="paragraph">
      2. 信息变更：若我们改变信息的收集、使用或共享方式，我们将提前通知您并获取您的同意。
    </p>


    <p class="paragraph">
      三、征得授权同意的例外
    </p>
    <p class="paragraph">
      在以下情形中，我们可能无需征得您的授权同意即可收集和使用您的信息：
    </p>
    <p class="paragraph">
      - 国家安全、国防安全直接相关；
    </p>
    <p class="paragraph">
      - 公共安全、公共卫生、重大公共利益直接相关；
    </p>
    <p class="paragraph">
      - 犯罪侦查、起诉、审判和判决执行直接相关；
    </p>
    <p class="paragraph">
      - 维护您或其他个人的生命、财产等重大合法权益；
    </p>
    <p class="paragraph">
      - 您已向社会公众公开的信息；
    </p>
    <p class="paragraph">
      - 合法公开披露的信息来源。
    </p>


    <p class="paragraph">
      四、Cookie和同类技术
    </p>
    <p class="paragraph">
      我们使用Cookie来提升您的使用体验。您可以管理或删除Cookie，但禁用可能影响APP或网站功能。
    </p>

    <p class="paragraph">
      关于移动安全联盟 OAID
    </p>
    <p class="paragraph">
      移动智能终端补充设备标识体系与 SDK 严格遵守我国《网络安全法》、《数据安全法》和《电信和互联网用户个人信息保护规定》等相关法律法规和《信息安全技术 个人信息安全规范》等国家标准要求。SDK 不会主动收集任何数据，只在
      APP调用时获取以下数据，用于本地判断，不会进行任何网络传输：设备制造商、设备型号、设备品牌，用于判断终端调用接口设备网络运营商名称，用于判断虚拟机环境APP 包名，用于校验签名。
    </p>

    <p class="paragraph">
      五、第三方SDK和服务
    </p>
    <p class="paragraph">
      我们的APP可能集成了以下第三方SDK和服务，以提供更好的用户体验：
    </p>
    <table style="word-break:break-all">
      <tr>
        <th style="width:10%">SDK名称</th>
        <th style="width:10%">包名信息</th>
        <th style="width:15%">使用目的</th>
        <th style="width:30%">使用的权限</th>
        <th style="width:15%">涉及个人信息</th>
        <th style="width:10%">隐私权政策链接/官网</th>
      </tr>
      <tr>
        <td>阿里weexSDK</td>
        <td>com.taobao</td>
        <td>uni-app基础模块默认集成，用于渲染uniapp的nvue页面引擎</td>
        <td style="font-size:12px"> android.permission.WRITE_EXTERNAL_STORAGE<br>
          android.permission.READ_EXTERNAL_STORAG </td>
        <td>存储的个人文件</td>
        <td><a href="https://weexapp.com/zh/" target="_blank">https://weexapp.com/zh/</a></td>
      </tr>
      <tr>
        <td>Fresco图库</td>
        <td>com.facebook.fresco</td>
        <td>用于nvue页面加载图片使用</td>
        <td style="font-size:12px"> android.permission.WRITE_EXTERNAL_STORAGE<br>
          android.permission.READ_EXTERNAL_STORAG </td>
        <td>存储的个人文件</td>
        <td><a href="https://www.fresco-cn.org/" target="_blank">https://www.fresco-cn.org/</a></td>
      </tr>
      <tr>
        <td>glide图库</td>
        <td>com.bumptech.glide</td>
        <td>用于图片预览使用</td>
        <td style="font-size:12px"> android.permission.WRITE_EXTERNAL_STORAGE<br>
          android.permission.READ_EXTERNAL_STORAG </td>
        <td>存储的个人文件</td>
        <td><a href="http://bumptech.github.io/glide/" target="_blank">http://bumptech.github.io/glide/</a></td>
      </tr>
      <tr>
        <td>gif-drawable</td>
        <td>pl.droidsonroids.gif</td>
        <td>加载gif图</td>
        <td style="font-size:12px"> android.permission.WRITE_EXTERNAL_STORAGE<br>
          android.permission.READ_EXTERNAL_STORAG </td>
        <td>存储文件</td>
        <td><a href="https://github.com/koral--/android-gif-drawable"
            target="_blank">https://github.com/koral--/android-gif-drawable</a></td>
      </tr>
      <tr>
        <td>移动安全联盟 OAID</td>
        <td>com.bun.miitmdid、com.zui.opendeviceidlibrary、com.netease.nis、com.samsung.android、com.huawei.hms</td>
        <td>获取oaid</td>
        <td style="font-size:12px"> 无 </td>
        <td>设备信息</td>
        <td><a href="http://www.msa-alliance.cn/col.jsp?id=122"
            target="_blank">http://www.msa-alliance.cn/col.jsp?id=122</a></td>
      </tr>
    </table>

    <p class="paragraph">
      六、信息共享、转让和公开披露
    </p>
    <p class="paragraph">
      我们不会与任何第三方共享您的个人信息，除非：
    </p>
    <p class="paragraph">
      - 获取您的明确同意；
    </p>
    <p class="paragraph">
      - 法律法规或政府要求；
    </p>
    <p class="paragraph">
      - 与我们的关联公司共享；
    </p>
    <p class="paragraph">
      - 与授权合作伙伴共享以提供服务。
    </p>

    <p class="paragraph">
      七、用户信息保护
    </p>
    <p class="paragraph">
      我们采取行业标准的安全措施来保护您的信息，包括SSL加密、HTTPS安全浏览、数据加密、访问控制等。
    </p>

    <p class="paragraph">
      八、信息安全事件
    </p>
    <p class="paragraph">
      若发生信息安全事件，我们将及时通知您并采取必要措施。
    </p>

    <p class="paragraph">
      九、联系我们
    </p>
    <p class="paragraph">
      如有任何疑问或需要帮助，请通过以下方式联系我们：
    </p>
    <p class="paragraph">
      - 电子邮件：info@honjoinfo.com
    </p>
    <p class="paragraph">
      - 地址：上海市徐汇区钦州北路1188号1幢15层1502（名义层1702室）
    </p>

    <p class="paragraph">
      产品及运营者信息
    </p>
    <p class="paragraph">
      - 产品名称：CSSD标签管家
    </p>
    <p class="paragraph">
      - 公司名称：上海红柚信息技术有限公司
    </p>
    <p class="paragraph">
      - 注册地址：上海市徐汇区钦州北路1188号1幢15层1502（名义层1702室）
    </p>
    <p class="paragraph">
      - 常用办公地址：上海市徐汇区钦州北路1188号1幢15层1502（名义层1702室）
    </p>

    <p class="paragraph">
      生效与变更
    </p>
    <p class="paragraph">
      本隐私政策自2024年5月7日起生效，并可能随时更新。任何变更将通过我们的APP或网站通知您。
    </p>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.privacy-rules {
  padding: 40px;
}

.title {
  text-align: center;
  font-size: 46px;
  font-weight: bold;
}

.paragraph {
  font-size: 42px;
  text-align: justify;
  margin: 30px 10px;
  text-indent: 84px;
}
</style>